import useApi from "../../api/useApi";

const useFavoriteService = () => {

  const {api} = useApi()

  const userShowStand = (callbackSuccess, callbackValidationErrors, standId) => {
    return api(
      'get',
      'user/favorites/add/stand/' + standId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors), //todo do error handling here
      error => {throw new Error(`Error in useFavoriteService::userShowStand: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userShowSpotGroup = (callbackSuccess, callbackValidationErrors, standId) => {
    return api(
      'get',
      'user/favorites/add/stand/' + standId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useFavoriteService::userShowSpotGroup: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userShowAll = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'user/favorites/show/all',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useFavoriteService::userShowAll: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userAddStand = (callbackSuccess, callbackValidationErrors, standId) => {
    return api(
      'get',
      'user/favorites/add/stand/' + standId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useFavoriteService::userAddStand: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userAddSpotGroup = (callbackSuccess, callbackValidationErrors, spotGroupId) => {
    return api(
      'get',
      'user/favorites/add/spot_group/' + spotGroupId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useFavoriteService::userAddSpotGroup: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userRemoveStand = (callbackSuccess, callbackValidationErrors, standId) => {
    return api(
      'get',
      'user/favorites/remove/stand/' + standId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useFavoriteService::userRemoveStand: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userRemoveSpotGroup = (callbackSuccess, callbackValidationErrors, spotGroupId) => {
    return api(
      'get',
      'user/favorites/remove/spot_group/' + spotGroupId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useFavoriteService::userRemoveSpotGroup: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    userShowStand,
    userShowSpotGroup,
    userShowAll,
    userAddStand,
    userAddSpotGroup,
    userRemoveStand,
    userRemoveSpotGroup,
  }
}

export default useFavoriteService
